import { FC, useMemo } from "react";
import { ChartOfAccountsTemplateListItem } from "@common/types/chartOfAccountsTemplate";
import { Button } from "@design-system/Button/Button";
import { Picker } from "@design-system/Picker/Picker.lib";
import styles from "../AddClientDrawerSteps.module.scss";
import { SetupStepFooter } from "./SetupStepFooter";

const TEMPLATE_PLACEHOLDER = "Select template";

interface Props {
    templates: ChartOfAccountsTemplateListItem[];
    selectedTemplateId: string | null;
    selectedTemplateName?: string;
    onSelectTemplate: (templateId: string) => void;
    onBack: () => void;
    onNext: () => void;
    onPreview: () => void;
}

export const CoaSourceSelect: FC<Props> = ({
    templates,
    selectedTemplateId,
    selectedTemplateName,
    onSelectTemplate,
    onBack,
    onNext,
    onPreview,
}) => {
    const isSourceSelected = selectedTemplateId !== null;
    const templateItems = useMemo(
        () =>
            templates.map((template) => ({
                value: template.id,
                label: template.name,
            })),
        [templates],
    );

    return (
        <div className={styles.container}>
            <div className={styles.header}>Use a template</div>
            <div className={styles.subheader}>
                Select a template for this entity's Chart of Accounts.
            </div>

            <div className={styles.coaSourceField}>
                <div className={styles.migrationSectionLabel}>
                    Source template
                </div>
                <Picker.Select
                    items={templateItems}
                    value={selectedTemplateId}
                    onValueChange={(templateId) => {
                        if (templateId !== null) {
                            onSelectTemplate(templateId);
                        }
                    }}
                    placeholder={TEMPLATE_PLACEHOLDER}
                    renderValue={() =>
                        selectedTemplateName ?? TEMPLATE_PLACEHOLDER
                    }
                    trigger={
                        <Picker.Button variant="primary" size="xl" block />
                    }
                />
                <Button
                    variant="secondary"
                    size="xl"
                    type="button"
                    onClick={onPreview}
                    disabled={!isSourceSelected}
                    block
                >
                    Preview Chart of Accounts
                </Button>
            </div>

            <SetupStepFooter
                onBack={onBack}
                onNext={onNext}
                isNextEnabled={isSourceSelected}
            />
        </div>
    );
};
